var _mask, _path, _rect, _rect2, _rect3, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChecklistIconActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_6600_1478",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 23.9997H16.0001C17.1047 23.9997 18.0001 23.1042 18.0001 21.9997V5.79123V2.99954C18.0001 1.89497 17.1047 0.999542 16.0001 0.999542H13.5001H2C0.895431 0.999542 0 1.89497 0 2.99954V21.9997C0 23.1042 0.895427 23.9997 2 23.9997Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 22.9997H2V24.9997H16.0001V22.9997ZM1 21.9997V2.99954H-1V21.9997H1ZM2 1.99954H13.5001V-0.000457764H2V1.99954ZM13.5001 1.99954H16.0001V-0.000457764H13.5001V1.99954ZM17.0001 2.99954V5.79123H19.0001V2.99954H17.0001ZM17.0001 5.79123V21.9997H19.0001V5.79123H17.0001ZM2 22.9997C1.44771 22.9997 1 22.552 1 21.9997H-1C-1 23.6565 0.343141 24.9997 2 24.9997V22.9997ZM16.0001 24.9997C17.657 24.9997 19.0001 23.6565 19.0001 21.9997H17.0001C17.0001 22.5519 16.5524 22.9997 16.0001 22.9997V24.9997ZM16.0001 1.99954C16.5524 1.99954 17.0001 2.44726 17.0001 2.99954H19.0001C19.0001 1.34269 17.657 -0.000457764 16.0001 -0.000457764V1.99954ZM1 2.99954C1 2.44726 1.44772 1.99954 2 1.99954V-0.000457764C0.343145 -0.000457764 -1 1.34269 -1 2.99954H1Z",
    fill: "#D91F05",
    mask: "url(#path-1-inside-1_6600_1478)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.26294,
    y: 12.0001,
    width: 9.94742,
    height: 1,
    rx: 0.5,
    fill: "#D91F05"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.26294,
    y: 7.50003,
    width: 9.94742,
    height: 1,
    rx: 0.5,
    fill: "#D91F05"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.26294,
    y: 16.5001,
    width: 9.94742,
    height: 1,
    rx: 0.5,
    fill: "#D91F05"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.47385,
    cy: 1.50001,
    rx: 1.89475,
    ry: 1.50001,
    fill: "#D91F05"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistIconActive);
export default __webpack_public_path__ + "static/media/checklistIconActive.4e6347cd57ef79c1ce81f2394963f6d1.svg";
export { ForwardRef as ReactComponent };